export const getISOStringInitDate = (date) => {
  const timestampInit = date.setHours(0, 0, 0)
  const dateInit = new Date(timestampInit)

  const year = dateInit.getFullYear()
  const month =
    dateInit.getMonth() + 1 >= 10 ? dateInit.getMonth() + 1 : '0' + (dateInit.getMonth() + 1)
  const day = dateInit.getDate() >= 10 ? dateInit.getDate() : '0' + dateInit.getDate()

  const newDate = year + '-' + month + '-' + day + 'T00:00:00.000Z'

  return newDate
}

export const formatTaskDate = (dateString, intl) => {
  if (!dateString) return '--'

  try {
    return intl.formatDate(new Date(dateString), {
      year: 'numeric',
      month: '2-digit',
      day: '2-digit',
      hour: '2-digit',
      minute: '2-digit',
    })
  } catch (error) {
    console.warn('Error formateando fecha:', dateString)
    return '--'
  }
}
